import { Component, Inject } from "@angular/core";
import { ApiService } from "app/api.service";
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "app-voucher-file-modal",
  templateUrl: "./voucher-file-modal.component.html",
  styleUrls: ["./voucher-file-modal.component.scss"],
})
export class VoucherFileModalComponent {
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  deleteIds: any[] = [];
  selectedItems = false;
  showLoader = false;
  allItemIds: number[] = [];
  isViewMode: boolean;
  voucherType: number;
  typeId: number;

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<VoucherFileModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id?: number;
      name?: string;
      uploadedFiles?: any[];
      images?: any[];
      isViewMode?: boolean;
      voucherType?: number;
    }
  ) {
    this.isViewMode = this.data.isViewMode || false;
    this.voucherType = this.data.voucherType;
    console.log("Fetched voucherssss Data:", this.data);
  }
  ngOnInit(): void {
    this.showLoader = true;
    if (this.data.images) {
      this.processUploadedFiles(this.data.images);
    } else if (this.data.id && this.voucherType) {
      this.fetchVoucherFilesById(this.data.id, this.voucherType);
    } else {
      console.error("Missing voucherTypeId or voucher ID");
    }
  }

  processUploadedFiles(files: any[]): void {
    this.imageUrls = [];
    this.documentUrls = [];

    for (let file of files) {
      if (!file.url) {
        file.url = file.preview || (file.image ? `${this.apiService.hostURL}/storage/${file.image}` : file.url);
      }

      if (this.isImage(file)) {
        this.imageUrls.push(file);
      } else if (this.isDocument(file.extension || '')) {
        this.documentUrls.push(file);
      }
    }

    this.showLoader = false;
  }

  fetchVoucherFilesById(id: number, typeId: number): void {
    this.allItemIds = [];
    this.imageUrls = [];
    this.documentUrls = [];
    this.showLoader = true;

    this.apiService.getVoucherFiles(id, typeId).subscribe((data: any) => {
      if (data.uploadedFiles && data.uploadedFiles.length) {
        for (let file of data.uploadedFiles) {
          if (!file.url) {
            file.url = file.preview || (file.image ? `${this.apiService.hostURL}/storage/${file.image}` : file.url);
          }
          if (this.isImage(file)) {
            this.imageUrls.push(file);
            this.allItemIds.push(file.id);
          } else if (this.isDocument(file.extension || '')) {
            this.documentUrls.push(file);
            this.allItemIds.push(file.id);
          }
        }
      }
      this.showLoader = false;
    });
  }

  isImage(file: any): boolean {
    const filePath = file?.image || file?.name || "";
    return (
      typeof filePath === "string" &&
      (filePath.toLowerCase().endsWith(".png") ||
        filePath.toLowerCase().endsWith(".jpg") ||
        filePath.toLowerCase().endsWith(".jpeg")||
        filePath.toLowerCase().endsWith(".webp")
      )
    );
  }

  isPDF(file: any): boolean {
    const filePath = file?.image || file?.name || "";
    return (
      typeof filePath === "string" && filePath.toLowerCase().endsWith(".pdf")
    );
  }

  isDocument(extension: string): boolean {
    return ["pdf", "doc", "docx", "xls", "xlsx"].includes(
      extension.toLowerCase()
    );
  }

  isPreviewable(extension: string): boolean {
    return ["jpg", "jpeg", "png", "gif", "bmp", "webp", "pdf"].includes(
      extension.toLowerCase()
    );
  }
  onCheckboxChange(id: number, name: string): void {
    const index = this.deleteIds.findIndex(
      (item) => item.id === id && item.name === name
    );

    if (index === -1) {
      this.deleteIds.push({ id, name });
    } else {
      this.deleteIds.splice(index, 1);
    }

    this.selectedItems = this.deleteIds.length > 0;
  }

  // deleteImg(): void {
  //   // if (!this.data.id || !this.voucherType) {
  //   //   console.error("Missing voucher ID or voucher type.");
  //   //   return;
  //   // }

  //   const filesToDelete = this.deleteIds.map((file) => ({
  //     id: file.id,
  //     name: file.name,
  //   }));

  //   this.apiService
  //     .deleteVoucherFile(this.data.id, this.voucherType, filesToDelete)
  //     .subscribe(
  //       (response) => {
  //         console.log("Files deleted successfully:", response);
  //         alert("Files deleted successfully");
  //         this.imageUrls = this.imageUrls.filter(
  //           (file) =>
  //             !this.deleteIds.some(
  //               (delFile) =>
  //                 delFile.id === file.id && delFile.name === file.name
  //             )
  //         );
  //         this.documentUrls = this.documentUrls.filter(
  //           (file) =>
  //             !this.deleteIds.some(
  //               (delFile) =>
  //                 delFile.id === file.id && delFile.name === file.name
  //             )
  //         );
  //         this.deleteIds = [];
  //         this.fetchVoucherFilesById(this.data.id, this.voucherType);
  //       },
  //       (error) => {
  //         console.error("Error deleting files:", error);
  //       },
  //       () => {
  //         this.showLoader = false;
  //       }
  //     );

  //   this.dialogRef.close();
  // }

  deleteImg(): void {
  const filesToDelete = this.deleteIds.map(f => ({
    id: f.id,
    name: f.name
  }));

  this.apiService
    .deleteVoucherFile(this.data.id, this.voucherType, filesToDelete)
    .subscribe(
      (response: any) => {
        alert("Files deleted successfully");

        // Return remaining files to parent
        this.dialogRef.close({
          remainingFiles: response.remaining_files
        });
      },
      (error) => {
        console.error("Error deleting files:", error);
      }
    );
}

  cancel(): void {
    this.dialogRef.close();
  }
}
